// extracted by mini-css-extract-plugin
export default {"container":"BaseTabList_container__lD+ZI","big":"BaseTabList_big__NCjDZ","small":"BaseTabList_small__gSnOo","bordered":"BaseTabList_bordered__Z0XBY"};